export default __webpack_public_path__ + "static/media/a6.4905d769.png";